import axiosApi from '../../../../axios/axios-api'

export const fetchAppointmentsByFicha = ({ commit }, fichaId) => {
  return new Promise((resolve, reject) => {
    axiosApi
      .get(`Turnos/Pacientes/${fichaId}`)
      .then(response => {
        var responseData = response.data
        var appointments = responseData.data
        appointments.forEach(element => {
          element.prestador = element.prestador.toLowerCase()
          element.servicio = element.servicio.toLowerCase()
        })
        commit('setAppointments', appointments)
        resolve()
      })
  })
}
export const fetchAppointmentsByDoc = (context, doc) => {
  return new Promise((resolve, reject) => {
    axiosApi
      .get(`Turnos/TurnosByDoc/${doc}`)
      .then(response => {
        if (response.data.data.length) {
          var responseData = [response.data.data[0]]
          var appointments = responseData.map(x => x.turno)
          var patients = responseData.map(x => x.paciente)
          context.commit('Patient/setPatients', patients, { root: true })
          appointments.forEach(element => {
            element.prestador = element.prestador.toLowerCase()
            element.servicio = element.servicio.toLowerCase()
          })
          context.commit('setAppointments', appointments)
        }
        resolve()
      })
  })
}
export const autoRecepcionarAppointments = ({ commit, state }, payload) => {
  return new Promise((resolve, reject) => {
    let url = `Turnos/${payload.turnoId}/Pacientes/${payload.fichaId}/AutoRecepcion/${payload.numRecId}?accionId=${payload.accionId}`
    if (payload.token) {
      url += `&token=${payload.token}`
    }
    axiosApi
      .get(url)
      .then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error.response.data)
      })
  })
}

export const generarNumeroRecepcion = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    axiosApi
      .post(
        'Turnos/NumeroRecepcion', data
      )
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export const pideToken = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    axiosApi
      .get(
        `Turnos/${payload.osId}/pide-token`
      )
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}
